module.exports = __webpack_public_path__ + "img/your_ejaculation.cb577887.jpg";